module.exports = __webpack_public_path__ + "70f9fc266784246661a227bb08044064.jpg";